import { render, staticRenderFns } from "./ModalHeader.vue?vue&type=template&id=7ee0c70a&scoped=true&"
import script from "./ModalHeader.vue?vue&type=script&lang=js&"
export * from "./ModalHeader.vue?vue&type=script&lang=js&"
import style0 from "./ModalHeader.vue?vue&type=style&index=0&id=7ee0c70a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee0c70a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ee0c70a')) {
      api.createRecord('7ee0c70a', component.options)
    } else {
      api.reload('7ee0c70a', component.options)
    }
    module.hot.accept("./ModalHeader.vue?vue&type=template&id=7ee0c70a&scoped=true&", function () {
      api.rerender('7ee0c70a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/elements/modal/ModalHeader.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/elements/modal/ModalHeader.vue
// module id = KL5h
// module chunks = 33